module.exports = __webpack_public_path__ + "static/media/lozsi.bb298834.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/lozsi.jpg
// module id = 543
// module chunks = 0